import IonIcon from '@reacticons/ionicons'
import { useRouter } from 'next/router'
import React from 'react'
import Modal from 'react-modal'

interface FreeASKAIPopupProps {
  heading: string
  title: JSX.Element
  createAccountButton?: boolean
  premiumSignupButton?: boolean
  isOpen: boolean
  onClose: () => void
}

const ModalStyles: Modal.Styles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    padding: '0px',
    transform: 'translate(-50%, -50%)',
    borderWidth: '0px',
    backgroundColor: 'transparent',
    border: '0px solid red',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: '90',
  },
}

const FreeASKAIPopup: React.FC<FreeASKAIPopupProps> = ({
  heading,
  title,
  createAccountButton = true,
  premiumSignupButton = true,
  isOpen,
  onClose,
}) => {
  const router = useRouter()

  const handleCreateAccount = () => {
    router.push('/signup/')
  }

  const handlePremiumSignup = () => {
    window.open('https://hub.legaltechnologyhub.com/more-info', '_blank')
  }

  if (!isOpen) return null

  return (
    <Modal closeTimeoutMS={200} isOpen={isOpen} onRequestClose={onClose} style={ModalStyles} ariaHideApp={false}>
      <div className="z-50  flex flex-col md:w-[700px] w-full md:pl-0 md:pr-0 pl-[20px] pr-[20px]">
        <div className="flex flex-row w-full z-70">
          <div className="ml-auto cursor-pointer text-textdark relative" onClick={onClose}>
            {/* <div className="w-4 h-4 m-2 rounded-md bg-white absolute z-70"></div> */}
            <IonIcon
              name="close-circle"
              className="!h-[30px] !w-[30px] relative z-990"
              style={{
                top: '0px',
                right: '0px',
                position: 'relative',
                zIndex: '999',
                color: '#FFF',
              }}
            />
          </div>
        </div>

        <div className={`flex flex-col overflow-y-hidden mt-[-25px] mr-[15px] z-50`}>
          <div className="bg-white rounded-[5px] flex flex-row w-full z-50  ">
            <div className="flex flex-col w-full z-50">
              <div className="h-2 rounded-t-[5px] bg-lightRoyalBlue"></div>
              <div className="flex flex-col p-10">
                <div className="flex flex-wrap mb-[10px]">
                  <h2 className="flex flex-wrap text-center askai-popup-heading">{heading}</h2>
                </div>
                <div className="flex flex-wrap mb-[10px] text-center askai-popup-title">{title}</div>
                <div>
                  <div className="w-full popup-button flex justify-center mt-[10px]">
                    {createAccountButton && (
                      <button
                        className="text-white py-2 px-12 mr-4 font-secondary text-[14px] font-bold text-center h-[50px] !important bg-navy rounded-[25px] w-[247px]"
                        onClick={handleCreateAccount}
                      >
                        Create an Account
                      </button>
                    )}
                    {premiumSignupButton && (
                      <button
                        className="text-white py-2 px-12 font-secondary text-[14px] font-bold text-center h-[50px] !important bg-navy rounded-[25px] w-[247px]"
                        onClick={handlePremiumSignup}
                      >
                        Sign Up for Premium
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default FreeASKAIPopup
